<template>
    <component
        :is="component"
        :tabIndex="tabIndex"
        :tabs="tabs"
        :currentTab="currentTab"
        :type="type"
        />
</template>

<script>
// eslint-disable-next-line import/no-unresolved,import/extensions
import games from '../config/games';
// eslint-disable-next-line import/no-unresolved
import base from '~/components/base.vue';
// eslint-disable-next-line import/no-unresolved
import desktop from '~/components/desktop/games/index.vue';

export default {
    extends: base,
    components: {
        desktop
    },
    data() {
        return {
            games,
            tabIndex: this.$getRoute(this.$route).path,
            currentTab: 'macau',
            type: {
                macau: 'tat-ca',
                vegas: 'tat-ca'
            },
            game: {
                display_type: 0,
                items: [],
                limit: 0,
                page: 0,
                totalPage: 0,
                type: 0
            },
            tabs: {
                macau: {
                    'tat-ca': this.game,
                    'game-bai': this.game,
                    'danh-bai': this.game,
                    'battle-game': this.game,
                    'no-hu': this.game,
                    'ban-ca': this.game,
                    ingame: this.game,
                    'quay-so': this.game,
                    'tro-choi-khac': this.game
                },
                vegas: {
                    'tat-ca': this.game,
                    'danh-bai': this.game,
                    'no-hu-vegas': this.game,
                    'no-hu-vegas-18': this.game,
                    'tro-choi-khac': this.game
                }
            }
        };
    },
    watch: {
        $route(to) {
            this.currentTab = to.query.tab ? to.query.tab : 'macau';
            this.type[this.currentTab] = to.query.type ? to.query.type : 'tat-ca';
        }
    },
    methods: {
        async init() {
            const res = await this.$gameApi.index();
            if (res.status === 'OK') {
                const gameOther = this.games.other.map(item => ({
                    ...item,
                    ...{
                        image: this.$store.state.mapDomain.STATIC_URL + item.image
                    }
                }));

                this.tabs.vegas['tat-ca'] = res.data.euro.featured ? res.data.euro.featured : this.game;
                this.tabs.vegas['danh-bai'] = res.data.euro.tables ? res.data.euro.tables : this.game;
                this.tabs.vegas['no-hu-vegas'] = res.data.euro.slots ? res.data.euro.slots : this.game;
                this.tabs.vegas['no-hu-vegas-18'] = res.data.euro.sexy_slots ? res.data.euro.sexy_slots : this.game;
                this.tabs.vegas['tro-choi-khac'] = res.data.euro.other ? res.data.euro.other : this.game;

                // this.tabs.macau['tat-ca'] = res.data.asia.featured ? res.data.asia.featured : this.game;
                if (res.data.asia.featured && this.games.other.length) {
                    const items = [...gameOther, ...res.data.asia.featured.items];
                    this.tabs.macau['tat-ca'] = { ...res.data.asia.featured, ...{ items } };
                } else {
                    this.tabs.macau['tat-ca'] = this.game;
                }
                this.tabs.macau['game-bai'] = res.data.asia.gamebai ? res.data.asia.gamebai : this.game;
                this.tabs.macau['danh-bai'] = res.data.asia.tables ? res.data.asia.tables : this.game;
                this.tabs.macau['battle-game'] = res.data.asia.battlegame ? res.data.asia.battlegame : this.game;
                this.tabs.macau['no-hu'] = res.data.asia.slots ? res.data.asia.slots : this.game;
                this.tabs.macau['ban-ca'] = res.data.asia.fishing ? res.data.asia.fishing : this.game;
                this.tabs.macau.ingame = res.data.asia.ingame ? res.data.asia.ingame : this.game;
                this.tabs.macau['quay-so'] = res.data.asia.lottery ? res.data.asia.lottery : this.game;
                if (res.data.asia.other && this.games.other.length) {
                    const items = [...gameOther, ...res.data.asia.other.items];
                    this.tabs.macau['tro-choi-khac'] = { ...res.data.asia.other, ...{ items } };
                } else {
                    this.tabs.macau['tro-choi-khac'] = this.game;
                }
            }
        }
    },
    created() {
        this.currentTab = this.$getRoute(this.$route).query.tab ? this.$getRoute(this.$route).query.tab : 'macau';
        this.type = {
            macau: this.currentTab === 'macau' && this.$getRoute(this.$route).query.type ? this.$getRoute(this.$route).query.type : 'tat-ca',
            vegas: this.currentTab === 'vegas' && this.$getRoute(this.$route).query.type ? this.$getRoute(this.$route).query.type : 'tat-ca'
        };
    },
    mounted() {
        this.$nextTick(async () => {
            this.init();
            this.$store.dispatch('getJackpot');
            this.jackPotInterval = setInterval(async () => {
                this.$store.dispatch('getJackpot');
            }, 5000);
        });
    },
    destroyed() {
        clearInterval(this.jackPotInterval);
    }
};
</script>
